var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechManufacturing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_23_",
    className: "st0",
    d: "M450,360.5c0,0-83.7,0-175.4,0c-2.8-6.3-6.6-12.3-11.8-17.5l-91.2-91.2l53.9-61.9h99.4 c2.1,0,4-0.4,6-0.6l49.4,49.4l81-54v-51.6h-22.7v39.4l-55.4,36.9l-29.8-29.8c10.3-8.3,17-20.9,17-35.1c0-3.1-0.3-6.2-0.9-9.1 c0,0,0-0.1,0-0.2c-2.7-13-11-23.9-21.8-30.1V93.8l55.4-36.9l38.9,38.9L458,79.6L406,27.6l-81,54v17.3L216.1,79.2 c-3.8-1.1-7.7-1.8-11.6-2.1l-4.6-0.8c-14.8,0-28.1,5.8-38.2,15.1c-0.6,0.6-1.4,1-2,1.6c-0.1,0.1-0.2,0.3-0.4,0.4 c0,0.1-0.1,0.1-0.2,0.2L53.8,214.4c-2.7,2.8-5.1,5.7-7.2,8.9c-0.3,0.4-0.4,0.9-0.7,1.3c-1.7,2.8-3.3,5.6-4.5,8.6c0,0.1,0,0.1,0,0.2 c-2.7,6.7-4.2,13.8-4.2,21.2c0,11.1,3.2,21.7,9.1,30.8c0.1,0.2,0.2,0.4,0.3,0.5c2.1,3.2,4.5,6.1,7.3,8.9l65.7,65.7 c-42.1,0-72.8,0-78.8,0C18,360.5,18,383.2,18,383.2v68.2c0,22.7,22.7,22.7,22.7,22.7s386.5,0,409.2,0c22.7,0,22.7-22.7,22.7-22.7 s0-45.5,0-68.2C472.7,360.5,450,360.5,450,360.5z M302.2,144.5c0-12.5,10.2-22.7,22.7-22.7c12.5,0,22.7,10.2,22.7,22.7 c0,12.5-10.2,22.7-22.7,22.7C312.4,167.3,302.2,157,302.2,144.5z M197.9,98.9l92.4,16.7c-6.6,7.9-10.7,17.9-10.7,29 c0,8.3,2.4,16,6.3,22.7h-85.9c-18.8,0-34.1-15.3-34.1-34.1C165.8,114.3,181.1,99.1,197.9,98.9z M144.4,145.1 c0.1,0.6,0.4,1.1,0.5,1.7c0.7,2.9,1.5,5.7,2.6,8.4c0.2,0.5,0.5,0.9,0.8,1.4c1.3,2.9,2.7,5.7,4.5,8.3c0.1,0.1,0.2,0.2,0.2,0.3 c2,2.9,4.2,5.6,6.7,8.1c0.9,0.9,2,1.6,3,2.4c0.7,0.6,1.4,1.2,2.1,1.8c3.8,3,7.8,5.6,12.2,7.5c0.3,0.1,0.5,0.3,0.8,0.4 c2.8,1.2,5.8,2,8.9,2.8c0.6,0.2,1.2,0.4,1.8,0.6c2.4,0.5,4.8,0.6,7.3,0.8l-40.3,46.2l-21.4-21.4c-9.8-9.8-23-14.9-36.5-15.8 L144.4,145.1z M128.1,254.6c0,9.1-3.6,17.7-10,24.1c-12.9,12.9-35.3,12.9-48.2,0c-6.4-6.4-10-15-10-24.1c0-9.1,3.6-17.7,10-24.1 c6.4-6.4,15-10,24.1-10s17.7,3.6,24.1,10C124.6,236.9,128.1,245.5,128.1,254.6z M101.9,310.7c12.2-1.7,23.5-7,32.3-15.9 c8.9-8.8,14.2-20.1,15.9-32.3l96.7,96.7c13.3,13.3,13.3,34.9,0,48.2c-12.9,12.9-35.4,12.9-48.2,0L101.9,310.7z M449.9,451.4H41.4 c-0.2,0-0.4,0-0.6-0.1v-67.5c0-0.2,0-0.4,0.1-0.6h101.4l40.2,40.2c10.7,10.7,25,16.7,40.2,16.7c15.2,0,29.5-5.9,40.2-16.7 c11.1-11.1,16.6-25.6,16.6-40.2h170.1c0.1,0,0.3,0,0.5,0.1v67.5C450,451,449.9,451.2,449.9,451.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "color_17_",
    className: "st1",
    cx: 200.5,
    cy: 132.8,
    r: 21.4
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechManufacturing;